import {
  createSetWorkFiguresDataAction,
  createSetPartsFiguresDataAction,
  createSetTransactionFiguresDataAction,
  createSetRentalFiguresDataAction,
  createSetVehicleFiguresDataAction,
  createSetTargetFiguresDataAction, createSetVehicleSummaryFigureDataAction, createSetPartOrderFigureData
} from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";
import {useTotalsData} from "./useTotalsData";
import {useCapTotalChangesData} from "./useCapTotalChangesData";
import {useVehicleSummaryData} from "./useVehicleSummaryData";
import {useMovementFigureData} from "./useMovementFigureData";

export const useFiguresData = (params) => {
  const partsLoading = useGetAndSet(
    "parts/figures",
    params,
    createSetPartsFiguresDataAction
  );
  const workLoading = useGetAndSet(
    "work/figures",
    params,
    createSetWorkFiguresDataAction
  );
  const transactionsLoading = useGetAndSet(
    "transactions/figures",
    params,
    createSetTransactionFiguresDataAction
  );
  const rentalsLoading = useGetAndSet(
    "rentals/figures",
    params,
    createSetRentalFiguresDataAction
  );
  const vehiclesLoading = useGetAndSet(
    "vehicles/figures",
    params,
    createSetVehicleFiguresDataAction
  );
  const targetsLoading = useGetAndSet(
    "targetlatest",
      {date: params.end, department: params.department},
    createSetTargetFiguresDataAction
  );
  const partOrderLoaded = useGetAndSet(
    "partorder/figure",
    params,
    createSetPartOrderFigureData
  );
  const totalsLoading = useTotalsData(params);
  const capLoaded = useCapTotalChangesData(params);
  const vehicleSummaryLoaded = useGetAndSet(
      "vehicles/summary",
      {start: params.start, department: params.department},
      createSetVehicleSummaryFigureDataAction
  )
  const movementLoaded = useMovementFigureData(params);
  return {
    transactionsLoading,
    workLoading,
    partsLoading,
    rentalsLoading,
    vehiclesLoading,
    targetsLoading,
    totalsLoading,
    capLoaded,
    vehicleSummaryLoaded,
    partOrderLoaded,
    movementLoaded
  };
};
